import { useState } from 'react';
import { EditOutlined } from '@ant-design/icons';
import { Button, Drawer } from 'antd';
import { observer } from 'mobx-react-lite';

import { useResource } from 'app/common/api';
import { useEntityGridConfig } from 'app/common/entity-grid/features/entity-grid/entity-grid-config.provider';
import {
  NotificationsRender,
  useNotifyFactory,
} from 'app/common/notifications/features/notifications';
import { DataGridApiProvider, useDataGridApi } from 'app/common/ui/data-grid';
import { useSelectedRows } from 'app/common/ui/data-grid/hooks';
import { Loading } from 'app/ui';

import { TTrip } from '../../../core/trips';
import { updateTripsRequest } from '../../../requests/update-trips.request';
import { ManageTripsGrid } from './manage-trips-grid';

type ManageTripsProps = {
  onChange?: (trips: TTrip[]) => void;
};
export const ManageTrips = observer((props: ManageTripsProps) => {
  const [displayDrawer, setDisplayDrawer] = useState(false);
  const { selectedRows } = useSelectedRows<TTrip>();
  const [editedRows, setEditedRows] = useState<TTrip[]>([]);
  const entityGridConfig = useEntityGridConfig();
  const getApiGrid = useDataGridApi();

  const notify = useNotifyFactory();
  const updateTripsResource = useResource<Partial<TTrip>[], { result: 0 }>({
    request: updateTripsRequest,
    errorNotify: notify,

    onDone: async () => {
      const gridApi = await getApiGrid();
      props.onChange && props.onChange(editedRows);
      setDisplayDrawer(false);
      entityGridConfig.resource.read();
      gridApi.deselectAll();
    },
  });

  const handleRowsSave = () => {
    updateTripsResource.send(editedRows);
  };

  const handleRowsChange = (rows: TTrip[]) => {
    setEditedRows(rows);
  };

  const hasSelectedRows = selectedRows.length > 0;
  const isLoading = updateTripsResource.isLoading;

  return (
    <>
      <Button
        onClick={() => setDisplayDrawer(true)}
        icon={<EditOutlined style={{ color: '#2664CD' }} />}
        disabled={!hasSelectedRows}
      >
        Управление рейсами
      </Button>

      <Drawer
        title="Редактирование данных рейсов"
        width="90%"
        destroyOnClose={true}
        open={displayDrawer}
        onClose={() => setDisplayDrawer(false)}
        footer={
          <div style={{ display: 'flex' }}>
            <Button
              type="primary"
              style={{ marginLeft: 'auto' }}
              onClick={handleRowsSave}
            >
              Сохранить
            </Button>
          </div>
        }
      >
        <Loading active={isLoading}>
          <NotificationsRender notifyStore={notify}>
            {(notifications) => (
              <div style={{ marginBottom: 16 }}>{notifications}</div>
            )}
          </NotificationsRender>

          <DataGridApiProvider>
            <ManageTripsGrid rows={selectedRows} onChange={handleRowsChange} />
          </DataGridApiProvider>
        </Loading>
      </Drawer>
    </>
  );
});
